<template>
  <div class="flex gap-1">
    <img class="w-[0.75rem] h-[0.882rem] mt-1" :src="icon" alt="Document icon" />
    <button class="link text-m" :disabled="!enabled" :data-test-id="dataTestId" @click="emit('linkClicked')">
      {{ linkText }}
    </button>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  linkText: string;
  enabled: boolean;
  enabledIcon: any;
  disabledIcon: any;
  dataTestId?: string;
}>();

const icon = ref(props.enabled ? props.enabledIcon : props.disabledIcon);
const emit = defineEmits(['linkClicked']);
</script>
